module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin10-6f35e08790da2d17cbc5ad56d69c0ac4.jpg";